import { InvoicingSettingsSection } from '../../../enums/invoicingSettingsSection'

export const invoicingSettingsSectionToTKey: Record<InvoicingSettingsSection, string> = {
  [InvoicingSettingsSection.Compliance]: 'invoicing_settings.compliance',
  [InvoicingSettingsSection.EInvoicing]: 'invoicing_settings.e_invoicing',
  [InvoicingSettingsSection.Invoice]: 'invoices',
  [InvoicingSettingsSection.LogoAndBranding]: 'invoicing_settings.logo_and_branding',
  [InvoicingSettingsSection.PaymentsAndReminders]: 'invoicing_settings.payments_and_reminders',
  [InvoicingSettingsSection.Presets]: 'invoicing_settings.presets',
  [InvoicingSettingsSection.Quote]: 'quotes',
}
